import { render } from "./AboutUsTeam.vue?vue&type=template&id=4bf31506&scoped=true"
import script from "./AboutUsTeam.vue?vue&type=script&lang=js"
export * from "./AboutUsTeam.vue?vue&type=script&lang=js"

import "./AboutUsTeam.vue?vue&type=style&index=0&id=4bf31506&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf31506"]])

export default __exports__